import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  changeLayoutMode,
  showRightSidebarAction,
  changeSidebarTheme,
} from "../../store/actions";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";

import "../../components/CommonForBoth/rightbar.scss";

// Constants
import { layoutModeTypes, leftSideBarThemeTypes } from "../../constants/layout";

const RightSidebar = (props) => {
  const handleThemeChange = (theme) => {
    props.changeLayoutMode(theme);
    props.changeSidebarTheme(theme === layoutModeTypes.DARK ? leftSideBarThemeTypes.DARK : leftSideBarThemeTypes.LIGHT);
  };

  return (
    <React.Fragment>
      <div className="right-bar" id="right-bar">
        <SimpleBar style={{ height: "900px" }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.showRightSidebarAction(false);
                }}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <h5 className="m-0">Settings</h5>
            </div>

            <hr className="my-0" />

            <div className="p-4">
              {/* Layouts Mode (Light/Dark) */}
              <hr className="mt-1" />
              <div className="radio-toolbar">
                <span className="mb-2 d-block">Layouts Mode</span>
                <input
                  type="radio"
                  id="radioLight"
                  name="radioLight"
                  value={layoutModeTypes.LIGHT}
                  checked={props.layoutModeType === layoutModeTypes.LIGHT}
                  onChange={() => handleThemeChange(layoutModeTypes.LIGHT)}
                />
                <label className="me-1" htmlFor="radioLight">Light</label>
                <input
                  type="radio"
                  id="radioDark"
                  name="radioDark"
                  value={layoutModeTypes.DARK}
                  checked={props.layoutModeType === layoutModeTypes.DARK}
                  onChange={() => handleThemeChange(layoutModeTypes.DARK)}
                />
                <label htmlFor="radioDark">Dark</label>
              </div>
            </div>
          </div>
        </SimpleBar>
      </div>
      <div className="rightbar-overlay"></div>
    </React.Fragment>
  );
};

RightSidebar.propTypes = {
  changeLayoutMode: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  showRightSidebarAction: PropTypes.func,
  layoutModeType: PropTypes.string,
  leftSideBarTheme: PropTypes.string,
};

const mapStateToProps = (state) => ({
  layoutModeType: state.Layout.layoutModeType,
  leftSideBarTheme: state.Layout.leftSideBarTheme,
});

export default connect(mapStateToProps, {
  changeLayoutMode,
  changeSidebarTheme,
  showRightSidebarAction,
})(RightSidebar);
